import React, { Fragment } from 'react'
import {
  Box,
  Button,
  Flex,
  Grid,
  Select,
  useDisclosure,
} from '@chakra-ui/react'
import { get } from 'lodash'

import { DashboardHeader, withApp } from '@/features/Layout'

import { Garbage } from '@/features/garbages/types'
import { Meta } from '@/features/filters/types'

import { Pagination } from '@/components/shared/Pagination'
import { UploadXlsxModal } from '@/components/shared/UploadXlsxModal'
import { GarbageTable } from './GarbageTable'

import { useMeta } from '@/features/filters'
import { useGarbages } from '@/features/garbages/queries'
import { useUploadGarbage } from '@/features/garbages/mutations'
import { t } from '@/lib/helpers'

type Props = {
  garbages: Garbage[]
  meta: Meta
  cities: { id: number; name: string }[]
}

function GarbagesPage(props: Props) {
  const { garbages: initialGarbages, meta: initialMeta, cities } = props

  const { meta, setMeta } = useMeta(initialMeta)
  const { onOpen, isOpen, onClose } = useDisclosure()

  const { data: garbages, isFetched } = useGarbages({
    initialData: { data: initialGarbages, meta: initialMeta },
    params: meta,
  })
  const { mutate: uploadGarbage, isLoading } = useUploadGarbage()

  return (
    <Fragment>
      <Box layerStyle="container">
        <DashboardHeader
          title={t('views.admin.garbages.index.title')}
          addons={
            <Grid
              sx={{
                gridTemplateColumns: 'repeat(2, max-content)',
                gap: '16px',
              }}
            >
              <Select
                size="lg"
                tabIndex={1}
                placeholder={t('views.admin.cities.form.select_city')}
                onChange={(e) => {
                  setMeta('city_id', e.target.value)
                }}
              >
                {cities.map((c) => (
                  <option key={c.name} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </Select>

              <Button onClick={onOpen} sx={{ h: '48px', w: '140px' }}>
                {t('views.admin.shared.misc.upload')}
              </Button>
            </Grid>
          }
        />

        <Box sx={{ mb: '24px' }}>
          <GarbageTable data={garbages.data} isLoading={!isFetched} />
        </Box>

        <Flex layerStyle="content" sx={{ justifyContent: 'flex-end' }}>
          <Pagination
            page={meta.page}
            per={meta.per}
            total={Number(get(garbages, 'meta.total'))}
            onChangePage={(page) => {
              setMeta('page', page)
            }}
          />
        </Flex>
      </Box>

      <UploadXlsxModal
        isOpen={isOpen}
        onClose={onClose}
        cities={cities}
        isLoading={isLoading}
        onSubmit={({ file, city_id }) =>
          uploadGarbage({ file, city_id }, { onSuccess: onClose })
        }
      />
    </Fragment>
  )
}

export default withApp(GarbagesPage)
